import { Cross } from "@/assets";
export default {
  name: "InputModal",
  components: { Cross },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },

    formData: {
      type: Object,
      default: function () {
        return {};
      },
    },

    title: {
      type: String,
      default: "",
    },

    enableSubmit: {
      type: Boolean,
      default: true,
    },

    submitBtnTitle: {
      type: String,
      default: "Create",
    },

    submitBtnType: {
      type: String,
      default: "primary",
    },

    enableCancel: {
      type: Boolean,
      default: true,
    },

    cancelBtnTitle: {
      type: String,
      default: "Create",
    },

    cancelBtnType: {
      type: String,
      default: "secondary",
    },

    // pixels
    height: {
      type: Number,
      default: 486,
    },

    // pixels
    width: {
      type: Number,
      default: 722,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    handleCancel: Function,
    handleOk: Function,
  },
  // data() {
  //   return {
  //     loading: false,
  //   };
  // },
  // computed: {
  //   ...mapState({
  //     loading: (state) => state.user.loading,
  //   }),
  // },
  computed: {
    heightCustom() {
      return `${this.height}px`;
    },
    widthCustom() {
      return `${this.width}px`;
    },
  },
  created() { },
  methods: {
    showModal() {
      this.visible = true;
    },
    onOk() {
      this.handleOk();
    },
    onCancel() {
      this.handleCancel();
    },
  },
};
